import React, { Component } from "react";
import config from 'react-global-configuration';
import axios from "axios";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class ServiceProductFilter extends Component {
  state = {
    productLists: [],
    productValue: null,
    isProductLoading: true
  };

  componentDidMount() {
    this._get_products();
  }

  resetProductFilter() {
    this.setState({
      productValue: []
    });
  }

  _get_products() {
    axios.get(config.get('API_URL') + '/filters/service_reports/get-product', {
      headers: {
        Authorization: ` ${localStorage.usertoken}`
      },
    })
      .then(response => {
        if (Array.isArray(response.data) && response.data.length) {
          const products = response.data.map(product => ({
            value: product.productname,
            label: product.productname
          }));
          this.setState({
            productLists: products,
            isProductLoading: false
          });
        } else {
          this.setState({ isProductLoading: false });
        }
      })
      .catch(err => {
        console.error('Error fetching products:', err);
        this.setState({ isProductLoading: false });
      });
  }

  changeProduct(optionSelected) {
    let productArray = [];
    if (!optionSelected || optionSelected.length === 0) {
      productArray = [];
    } else {
      productArray = optionSelected.map(item => item.value);
    }
    this.props.onSelectProduct(optionSelected, productArray);
    this.setState({
      productValue: optionSelected,
    });
  }

  render() {
    return (
      <ReactMultiSelectCheckboxes
        name="product"
        isMulti
        value={this.state.productValue}
        styles={reactSelectStyles}
        className="report-listbox"
        isClearable={false}
        onChange={this.changeProduct.bind(this)}
        options={this.state.productLists}
        placeholderButtonLabel="Select [Product]"
        isLoading={this.state.isProductLoading}
      />
    );
  }
}

export default ServiceProductFilter;
